import { render, staticRenderFns } from "./JournalPage.vue?vue&type=template&id=1a3a666f&scoped=true&lang=pug&"
import script from "./JournalPage.vue?vue&type=script&lang=js&"
export * from "./JournalPage.vue?vue&type=script&lang=js&"
import style0 from "./JournalPage.vue?vue&type=style&index=0&id=1a3a666f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3a666f",
  null
  
)

export default component.exports